// The SDK, configured once.
//
// The endpoint and the project id are public by design and ship in the
// bundle; that is what the web SDK is for. NO API KEY EVER REACHES THIS FILE
// or any other file under src/. The deletion Function's key lives in the
// Function's environment. If a permission problem ever looks like it wants a
// key here, the permission model is wrong, not the key's location.

import { Account, Client, Functions, Storage, TablesDB } from "appwrite";

// BUN_PUBLIC_ so Bun inlines them into the client bundle, and so that nothing
// without the prefix can reach the browser by accident. apps/web/build.ts also defines
// them explicitly, so production does not depend on that inlining.
const endpoint = process.env.BUN_PUBLIC_APPWRITE_ENDPOINT ?? "";
const project = process.env.BUN_PUBLIC_APPWRITE_PROJECT ?? "";

export const client = new Client().setEndpoint(endpoint).setProject(project);

export const account = new Account(client);
export const tables = new TablesDB(client);
export const storage = new Storage(client);
export const functions = new Functions(client);

export const DB = "app";
export const EVENTS = "events";
export const SNAPSHOTS = "snapshots";
export const DELETE_FUNCTION = "delete-account";

export const CONTENT_BUCKET = "content";
export const RELEASES = "content-releases";
export const CURRENT_RELEASE_ROW = "current";
